import React from 'react';
import axios from 'axios';

import {authConfig} from '../../configures/awsConfig.js'
import {SESSION_INIT_URL, TERM_VER} from '../../configures/val.js'
import { Auth } from 'aws-amplify';
import { I18n } from '@aws-amplify/core';
import QueryStrUtil from '../util/queryStrUtil.js'

import checkTermsVer from '../util/checkTermsVer.js';

import "./archlikestyle/css/base.css";
import "./archlikestyle/css/reset.css";
import "./archlikestyle/login/css/solarA/loginWidget.css";
import "./archlikestyle/login/tablet/css/LoginPage.css";

import idIcon from "./archlikestyle/login/img/login_id_icon.png"
import pwIcon from "./archlikestyle/login/img/login_pw_icon.png"

const myQueryStrUtil = new QueryStrUtil();

export default class ArchLikeSignIn extends React.Component {
  constructor(props) {
    super(props);

    this.signIn = this.signIn.bind(this);

    this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];
    this.userAgent = '';
    // loadStatus : Now loading を表示するかどうか
    this.state = {
      errorStr: '',
      idtext:'',
      pwtext:'',
      loadStatus: 1
    };
    this.getUserAgent();
  }
  redirectArchWithToken = (url, token) => {
    const queries = {
      refresh_token: token,
      client_id: authConfig.userPoolWebClientId,
      autologin: 'save'
    };
    const destination = myQueryStrUtil.hrefUrl(queries, url);
    window.location.href = destination;
  }
  checkUser = () => {
    const that = this;
    return Auth.currentAuthenticatedUser().then(user => {
      if (!that._isMounted) { return; }
      Auth.userAttributes(user).then((attrRet) => {
        const isLowVer = checkTermsVer(attrRet, 'custom:agreed_term', TERM_VER, 'ver');
        if (isLowVer) {
          window.location.href = '/?to=' + window.location;
          return;
        }
        // ログイン済みで正しくトークンが生きている
        const redirectUri = myQueryStrUtil.getParamContent('callback');
        this.redirectArchWithToken(redirectUri, user.signInUserSession.refreshToken.token);
      }).catch((attrErr) => {
        // トークンが死んでいる可能性がある
        Auth.signOut().then(() => {
          this.setState({
            loadStatus: 0
          });
        });
      });
    }).catch(err => {
      if (!that._isMounted) { return; }
      Auth.signOut().then(() => {
        this.setState({
          loadStatus: 0
        });
      });
    });
  }
  componentDidMount() {
    document.title = I18n.get('L eye LOGIN');

    this._isMounted = true;
    this.checkUser();

    // ARCHからのリダイレクトでNGが返ってきたらそれを表示する
    if (myQueryStrUtil.getParamContent('result') !== '') {
      const tmpStr = I18n.get('Entered credentials are incorrect.');
      this.setState({errorStr: tmpStr});
      return;
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  resetError = () => {
    this.setState({
      errorStr: '',
      idtext:'',
      pwtext:''
    });
  }
  makeSession = (datum) => {
    const {user} = datum;
    const urlStr = SESSION_INIT_URL+'client_id='+authConfig.userPoolWebClientId+'&refresh_token='+user.signInUserSession.refreshToken.token;
    axios.get(
      urlStr,
      {
        headers: {
          'Content-Type': 'plain/text',
        },
        withCredentials: true,
      }
    ).then((response) => {
      this.resetError();
    }).catch(err => {
      console.log(err);
      this.resetError();
    });
  }
  getErrorMessage = (err) => {
    const {code, message} = err;
    if (!code && !message)
      return err;
    if (message)
      return message;
    if (code)
      return code;
    return '';
  }
  handleSignInError = (userData, mes) => {
    if (mes === 'User is not confirmed.') {
      // confirmedじゃないならエラーメッセージ出して終わり
      this.resetError();
      return;
    }
    let errorStr = '';
    if (mes === '') {
      this.setState({
        errorStr
      });
      return;
    }
    if(
      mes === 'Username cannot be empty' ||
      mes === 'User does not exist.'
    ) {
      errorStr = I18n.get(mes);
    }
    if(
      mes === 'Incorrect username or password.' ||
      mes === 'null failed with error Generate callenges lambda cannot be called..'
    ) {
      if (mes === 'null failed with error Generate callenges lambda cannot be called..') {
        mes = 'Enter your password'
      }
      errorStr = I18n.get(mes);
    }
    if (errorStr !== '') {
      this.setState({
        errorStr
      });
      return;
    }
    this.error(I18n.get(mes));
  }
  isError = () => {
    const idErr = I18n.get('Enter your ID');
    if (this.state.idtext === '') {
      this.setState({
        errorStr: idErr
      });
      return true;
    }
    if (this.state.pwtext === '') {
      const pwErr = I18n.get('Enter your password');
      this.setState({
        errorStr: pwErr
      });
      return true;
    }
    return false;
  }
  checkArchLogin = (redirectUri) => {
    // ラプラスIDでない場合はリダイレクト
    const queries = {
      idtext: this.state.idtext,
      pwtext: this.state.pwtext,
      autologin: 'save'
    };
    window.location.href = myQueryStrUtil.hrefUrl(queries, redirectUri);
  }
  checkRedirect = (e) => {
    e.preventDefault();
    if (this.isError())
      return;
    const redirectUri = myQueryStrUtil.getParamContent('callback');
    // ラプラスIDかどうか
    if (!this.state.idtext.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      this.checkArchLogin(redirectUri);
    } else {
      this.signIn(this.state.idtext, this.state.pwtext, redirectUri);
    }
  }
  async signIn(username, password, redirectUri) {
    if (!Auth || typeof Auth.signIn !== 'function') {
        throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    const userData = {
      username: username,
      pw: password
    };
    let user;
    try {
      user = await Auth.signIn(username, password);
    } catch (err) {
      const str = this.getErrorMessage(err);
      this.handleSignInError(userData, str);
      return;
    }
    const result = await Auth.userAttributes(user);
    const isLowVer = checkTermsVer(result, 'custom:agreed_term', TERM_VER, 'ver');
    if (isLowVer) {
      // 利用規約確認後に、飛び先に移動するよう to で飛び先情報をパスする
      window.location.href = '/?to=' + window.location;
      return;
    }
    // リダイレクト
    this.redirectArchWithToken(redirectUri, user.signInUserSession.refreshToken.token);
  }
  getUserAgent = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('iPhone') > 0 || userAgent.indexOf('Android') > 0 || userAgent.indexOf('iPad') > 0) {
      this.userAgent = 'mobile';
    } else {
      this.userAgent = 'pc';
    }
  }
  getSpecificUri = (destination) => {
    const uriStrArr = myQueryStrUtil.getParamContent('callback').split('/');
    let uriStr = '';
    for (let i = 0; i < uriStrArr.length; i++) {
      if ('login' === uriStrArr[i])
        break;
      uriStr += uriStrArr[i];
      uriStr += '/';
    }
    uriStr += destination;
    return uriStr;
  }
  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }
  getArchForgotPass = () => {
    return this.getSpecificUri('login/confirm/index.php');
  }
  switchPcLoadView = () => {
    if (this.state.loadStatus === 0) {
      return (
        <form id="loginform" onSubmit={this.checkRedirect}>
          <div id="loginWidget">
            <div className="widgetBody">
              <div className="editArea">
                <ul>
                  <li><img src={idIcon} alt="id" />
                    <p>ID</p><input type="text" name="idtext" className="userinfoAre" onChange={this.handleChange} />
                  </li>
                  <li>
                  <img src={pwIcon} alt="pass word" />
                    <p>{I18n.get('Password')}</p><input type="password" name="pwtext" className="userinfoAre" onChange={this.handleChange} />
                  </li>
                </ul>
                <div className="notes">{this.state.errorStr}</div>
              </div>
              <div className="saveArea">
                <div className="btnArea">
                  <div className="resetBtn"><a href={this.getArchForgotPass()} style={{"fontFamily": "Geneva, sans-serif", "fontSize": "11px"}}>{I18n.get('Forgot ID/Password')}</a></div>
                  <div className="loginBtn"><button type='submit'>{I18n.get('Log In')}</button></div>
                </div>
              </div>
            </div>
          </div>
        </form>
      );
    } else {
      return (
        <p id="loadingText">{I18n.get('Now loading...')}</p>
      ); 
    }
  }
  displayPcView = () => {
    return (
      <div id="archLikeBody">
        <div id="wrapper">
          <div className="headerMenu"></div>
          <div id="main" style={{"paddingTop": "2px"}}>
            {this.switchPcLoadView()}
          </div>
        </div>
        <div id="footer" style={{"position": "fixed"}}>
          <p>Copyright (C) 2012- Laplace System Co., Ltd. All rights reserved.</p>
        </div>
      </div>
    );
  }
  switchMobileLoadView = () => {
    if (this.state.loadStatus === 0) {
      return (
        <div id="controlsBackground" className="container mcontainer">
          <div id ="idLogo" className="imgLogo"></div>
          <div className="message">{I18n.get('Enter your ID and Password.')}</div>
          <label className="textLbl">ID</label>
          <input type="text"className="textbox" name="idtext" onChange={this.handleChange}/>
          <label className="textLbl">Password</label>
          <input type="password" className="textbox" name="pwtext" onChange={this.handleChange}/>
          <div className ="buttonContainer">
            <label className="errorLbl">{this.state.errorStr}</label>
            <div className="button">
              <button onClick={this.checkRedirect}>{I18n.get('Log In')}</button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="controlsBackground" className="container mcontainer">
          <p id="loadingText">{I18n.get('Now loading...')}</p>
        </div>
      );
    }
  }
  displayMobileView = () => {
    return (
      <div className="fullPage">
        {this.switchMobileLoadView()}
      </div>
    );
  }
  render () {
    if (this.userAgent === 'pc') {
      return(this.displayPcView());
    } else {
      return(this.displayMobileView());
    }
  }
}
